import { WidgetContainer } from '@pulse-web-ui/containers';
import { media, styled, typography } from '@pulse-web-ui/theme';

import type { SummaryContainerProps } from './summary.types';

export const Container = styled(WidgetContainer)<SummaryContainerProps>`
  display: flex;
  flex-direction: ${({ $isOpen, $withSummary }) =>
    $isOpen ? 'column' : $withSummary ? 'row-reverse' : 'initial'};
  justify-content: ${({ $isOpen, $withSummary }) =>
    $isOpen ? 'initial' : $withSummary ? 'space-between' : 'center'};
  align-items: ${({ $isOpen, $withSummary }) =>
    $isOpen ? 'initial' : $withSummary ? 'flex-end' : 'center'};
  padding: 24px;
  gap: 16px;
`;

export const TitleContainer = styled.div<SummaryContainerProps>`
  display: flex;
   cursor: ${({ $isOpen }) => (!$isOpen ? 'pointer' : 'initial')};
  align-items: center;
  margin-left: ${({ $isOpen, $withSummary }) => (!$isOpen && $withSummary ? 'auto' : 0)};
    
  ${media.desktop} {
    align-self:: initial;
  }
`;

export const Title = styled.p<{ $isOpen: boolean }>`
  ${typography.medium20}
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 20px;
  margin: 0;
  margin-left: ${({ $isOpen }) => ($isOpen ? 0 : '5px')};
`;

export const IconButton = styled.div`
  margin-left: auto;
  cursor: pointer;
`;

export const ItemData = styled.div<{
  $isPrimary?: boolean;
  $isTotal?: boolean;
}>`
  color: ${({ $isPrimary, theme }) =>
    $isPrimary ? theme.colors.text.primary : theme.colors.text.secondary};
  font-size: ${({ $isPrimary, $isTotal }) =>
    $isTotal ? '12px' : $isPrimary ? '16px' : '14px'};
  line-height: ${({ $isPrimary }) => ($isPrimary ? '24px' : '20px')};
`;

export const Separator = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.neutral[30]};
`;
